/* @flow */
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import cx from 'classnames'

export class ValidateInput extends Component {

  constructor (props, context) {
    super (props, context)

    const value = this.props.value
    this.state = { value }
  }

  static propTypes = {
    className: PropTypes.string,
    onEnter: PropTypes.func,
    onChange: PropTypes.func,
    validation: PropTypes.func,
    validationExpression: PropTypes.instanceOf(RegExp),
    rejectExpression: PropTypes.instanceOf(RegExp),
    value: PropTypes.any,
    characterLimit: PropTypes.number
  }

  static defaultProps = {
    onEnter: _.noop,
    onChange: (value) => value,
    value: '',
  }

  componentDidMount () {
    if (this.props.autofocus) ReactDOM.findDOMNode(this._input).focus()
  }

  componentWillReceiveProps (nextProps) {
    const {value} = this.props
    if (nextProps.value !== value && this.state.value === value)
      this.setState({ value: nextProps.value })
  }

  isValid (value) {
    const { validation, validationExpression } = this.props

    return validation && validation(value)
      || validationExpression && validationExpression.test(value)
      || !validation && !validationExpression
  }

  focus () {
    const node = ReactDOM.findDOMNode(this._input)
    if (node && !this.props.disabled) node.focus()
  }

  onEnter (e) {
    e.preventDefault()
    if (this.state.isValid) this.props.onEnter(e)
  }

  onChange (e) {
    const {characterLimit, rejectExpression, onChange} = this.props
    let { value } = e.target

    if (rejectExpression) value = value.replace(rejectExpression, '')
    if (characterLimit) value = value.slice(0, characterLimit)

    this.setState({ value: this.props.onChange(value, this.state.value) })
  }

  render () {
    const { value } = this.state
    const isValid = this.isValid(value)

    return (
      <input
        {...this.props}
        ref={(r) => this._input = r}
        onChange={this.onChange.bind(this)}
        value={ this.state.value }
        className={cx(this.props.className, { 'm--invalid': isValid })}
      />
    )
  }
}
